import {InaccessibleInfo} from 'auth/RequestAccess';
import {ManagedModelTypes} from 'models/ManagedModelDefinitions';

export enum ManagedModelsActionTypes {
  MODEL_FETCHED = 'MODEL_FETCHED',
  MODEL_INACCESSIBLE = 'MODEL_INACCESSIBLE',
}

interface ModelFetchedAction<K extends keyof ManagedModelTypes> {
  type: ManagedModelsActionTypes.MODEL_FETCHED;
  modelType: K;
  modelsByKey: {[key: string]: ManagedModelTypes[K]};
}
export function modelFetched<K extends keyof ManagedModelTypes>(
  modelType: K,
  modelsByKey: {[key: string]: ManagedModelTypes[K]}
): ModelFetchedAction<K> {
  return {
    type: ManagedModelsActionTypes.MODEL_FETCHED,
    modelType,
    modelsByKey,
  };
}

interface ModelInaccessibleAction<K extends keyof ManagedModelTypes> {
  type: ManagedModelsActionTypes.MODEL_INACCESSIBLE;
  modelType: K;
  inaccessibleInfoByKey: {[k: string]: InaccessibleInfo};
}
export function modelInaccessible<K extends keyof ManagedModelTypes>(
  modelType: K,
  inaccessibleInfoByKey: {[k: string]: InaccessibleInfo}
): ModelInaccessibleAction<K> {
  return {
    type: ManagedModelsActionTypes.MODEL_INACCESSIBLE,
    modelType,
    inaccessibleInfoByKey,
  };
}

export function modelKeysToInaccessibleInfoByKey(inaccessibleModelKeys: Array<string>): {
  [k: string]: InaccessibleInfo;
} {
  const inaccessibleInfoByKey: {[k: string]: InaccessibleInfo} = {};
  for (const modelKey of inaccessibleModelKeys) {
    inaccessibleInfoByKey[modelKey] = {invalidId: modelKey};
  }
  return inaccessibleInfoByKey;
}

export type ManagedModelsAction =
  | ModelFetchedAction<keyof ManagedModelTypes>
  | ModelInaccessibleAction<keyof ManagedModelTypes>;
